import React from 'react'
import Navbar from '../components/Navbar/Navbar'
import Footer from '../components/Footer/Footer'

import Aboutheader from '../components/About/Aboutheader'
import SpecialOffer from '../components/Home/SpecialOffer'
import SpaServices from '../components/About/SpaServices'
import Faq from '../components/About/Faq'


const Aboutpage = () => {
    return (
        <div>
        <Navbar/>
  
        <Aboutheader/>
        <SpaServices/>
        <Faq/>

        <SpecialOffer/>



        <Footer/>

        </div>
    )
}

export default Aboutpage